import React from "react";

const PageTitle = ({
  tag: Tag = "h5", // h1, h2, h3, h4, h5, h6 or p div
  title,
  icon,
  iconPosition = "left",
  gap = "gap-3",
  className=""
}) => {
  const iconSizes = {
    h1: "!text-[60px]",
    h2: "!text-[50px]",
    h3: "!text-[40px]",
    h4: "!text-[35px]",
    h5: "!text-[30px]",
    h6: "!text-[25px]",
    p: "!text-[20px]",
    div: "!text-[20px]",
  };

  return (
    // <div className={`flex ${gap} items-center justify-center`}>
    <div className={`flex ${gap} items-center ${className}`}>
      {icon && iconPosition === "left" && (
        <span className={`material-symbols-rounded ${iconSizes[Tag]}`}>
          {icon}
        </span>
      )}
      <Tag>{title}</Tag>
      {icon && iconPosition === "right" && (
        <span className={`material-symbols-rounded ${iconSizes[Tag]}`}>
          {icon}
        </span>
      )}
    </div>
  );
};

export default PageTitle;
